import { useState } from "react";
import "./restaurant-kitchen-order.styles.scss";
const RestaurantKitchenOrder = ({ orderObject, index, changeOrderStatus }) => {
  const orderType = orderObject["metadata"];
  var tableNumber;
  if (orderType === "tableside") {
    tableNumber = orderObject["tableNumber"];
  }
  const orderDetails = orderObject["order"];
  const orderStatus = orderObject["status"];
  const orderMessage = orderObject["message"];
  const [orderClass, setOrderClass] = useState(
    "restaurant-kitchen-fullorder-minimize"
  );

  const handleClick = () => {
    if (orderClass === "restaurant-kitchen-fullorder-minimize") {
      setOrderClass("restaurant-kitchen-fullorder");
    } else if (orderClass === "restaurant-kitchen-fullorder") {
      setOrderClass("restaurant-kitchen-fullorder-minimize");
    }
  };
  return (
    <div key={index} className="restaurant-kitchen-order" onClick={handleClick}>
      <div className="restaurant-kitchen-order-details">
        <span className="rk-order-number">
          <span className="rk-order-tag">Order No : </span>
          {index}
        </span>
        <span className="rk-order-type">
          <span className="rk-order-tag">Type : </span>
          {orderType}
        </span>
        {orderType === "tableside" && (
          <span className="rk-order-tablenumber">
            <span className="rk-order-tag">Table No : </span>
            {tableNumber}
          </span>
        )}
        <span className="rk-order-status">{orderStatus}</span>
        {orderStatus === "Order Placed" && (
          <span
            className="rk-order-change"
            onClick={() => changeOrderStatus(index, "Preparing")}
          >
            Start Preparing
          </span>
        )}
        {orderStatus === "Preparing" && (
          <span
            className="rk-order-change"
            onClick={() => changeOrderStatus(index, "Done")}
          >
            Send to floor
          </span>
        )}
      </div>
      {orderMessage !== "" && (
        <div className="rk-order-message-container">
          <span className="rk-order-message">
            <span className="rk-order-tag">Instructions : </span>
            <br />
            {orderMessage}
          </span>
        </div>
      )}

      <div className={orderClass}>
        <span className="restaurant-kitchen-fullorder-title">
          Order Details
        </span>
        {Object.keys(orderDetails).map((i) => {
          const tempobj = orderDetails[i];
          return (
            <div key={i} className="rk-order-item">
              <span className="rk-order-itemname">{i}</span>
              <span className="rk-order-count">
                &nbsp;x {tempobj["itemCount"]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default RestaurantKitchenOrder;
